import React, { useState } from "react";

const RequirementLine = ({ req, showStatus = false }) => {
    const label = req.specific
        ? `${req.count} ${req.type} (${req.specific})`
        : `${req.count} ${req.type}`;
    return (
        <div className="elig-req-item">
            {showStatus ? (
                <span
                    className={`elig-req-dot ${req.met ? "elig-req-dot--met" : "elig-req-dot--missing"}`}
                />
            ) : (
                <span className="elig-req-dot elig-req-dot--met" />
            )}
            <span className="elig-req-text">{label}</span>
        </div>
    );
};

const ProgramCard = ({
    program,
    showMissing = false,
    onViewColleges,
    index = 0,
}) => {
    const [showOtherPaths, setShowOtherPaths] = useState(false);
    const { allCombinations } = program;
    const primaryCombo = allCombinations[0];
    const otherCombos = allCombinations.slice(1);

    // Determine the category color
    const categoryColors = {
        Languages: { bg: "#eef2ff", text: "#4338ca", border: "#c7d2fe" },
        "Arts & Social Sciences": { bg: "#fef3c7", text: "#92400e", border: "#fde68a" },
        "Science, Math & Tech": { bg: "#ecfdf5", text: "#065f46", border: "#a7f3d0" },
        "Commerce & Management": { bg: "#fce7f3", text: "#9d174d", border: "#fbcfe8" },
        "Music & Fine Arts": { bg: "#fae8ff", text: "#7e22ce", border: "#e9d5ff" },
        "Fine Arts": { bg: "#fae8ff", text: "#7e22ce", border: "#e9d5ff" },
        Vocational: { bg: "#f0fdf4", text: "#166534", border: "#bbf7d0" },
        Education: { bg: "#eff6ff", text: "#1e40af", border: "#bfdbfe" },
    };

    const colors = categoryColors[program.category] || {
        bg: "#f1f5f9",
        text: "#475569",
        border: "#e2e8f0",
    };

    return (
        <div
            className="elig-pcard"
            style={{ animationDelay: `${Math.min(index * 0.04, 0.4)}s` }}
        >
            {/* Top accent bar */}
            <div
                className="elig-pcard__accent"
                style={{ background: colors.text }}
            />

            {/* Header */}
            <div className="elig-pcard__header">
                <h3 className="elig-pcard__name">{program.name}</h3>
                <span
                    className="elig-pcard__cat-badge"
                    style={{
                        background: colors.bg,
                        color: colors.text,
                        borderColor: colors.border,
                    }}
                >
                    {program.category}
                </span>
            </div>

            {/* Primary combination */}
            <div className="elig-pcard__combo">
                <div className="elig-pcard__combo-title">
                    {primaryCombo.name}
                </div>
                <div className="elig-pcard__reqs">
                    {primaryCombo.requirementStatuses.map((req, i) => (
                        <RequirementLine
                            key={i}
                            req={req}
                            showStatus={showMissing}
                        />
                    ))}
                </div>
            </div>

            {/* Other paths accordion */}
            {otherCombos.length > 0 && (
                <div className="elig-pcard__accordion">
                    <button
                        className="elig-pcard__accordion-trigger"
                        onClick={() => setShowOtherPaths(!showOtherPaths)}
                    >
                        <span
                            className={`elig-pcard__accordion-icon ${showOtherPaths ? "elig-pcard__accordion-icon--open" : ""}`}
                        >
                            ▶
                        </span>
                        <span>
                            {otherCombos.length} other eligibility{" "}
                            {otherCombos.length === 1 ? "path" : "paths"}
                        </span>
                    </button>
                    {showOtherPaths && (
                        <div className="elig-pcard__accordion-body">
                            {otherCombos.map((combo, idx) => (
                                <div className="elig-pcard__combo" key={idx}>
                                    <div className="elig-pcard__combo-title">
                                        {combo.name}
                                    </div>
                                    <div className="elig-pcard__reqs">
                                        {combo.requirementStatuses.map(
                                            (req, i) => (
                                                <RequirementLine
                                                    key={i}
                                                    req={req}
                                                    showStatus={showMissing}
                                                />
                                            )
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* Footer action */}
            <div className="elig-pcard__footer">
                <button
                    className="elig-pcard__action"
                    onClick={() => onViewColleges(program)}
                >
                    <span className="elig-pcard__action-icon">🏛️</span>
                    <span>View Colleges (Seats/Cutoffs)</span>
                    <span className="elig-pcard__action-arrow">→</span>
                </button>
            </div>
        </div>
    );
};

export default ProgramCard;
